var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 col-xs-12"},[_c('ProductComparison',{attrs:{"isPublic":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }